/* =====================================================================
   DEAD COTTON — Fiche produit (portage de initPDP() du prototype, assets/app.js)
   Données Shopify lues dans <script id="dc-pdp-data"> (variantes, index des options couleur / taille).
   Galerie : toutes les photos du produit sont dans le DOM ; on n'en montre que celles de la couleur choisie
   (une couleur = la photo liée à ses variantes + les photos qui suivent jusqu'à la couleur suivante).
   États : dc-is-active / dc-is-open / dc-is-on (comme le reste du thème).
   ===================================================================== */
(function () {
  var root = document.querySelector("[data-dc-pdp]");
  if (!root) return;
  var dataEl = document.getElementById("dc-pdp-data");
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = cfg.variants || [];
  var ci = cfg.colorIdx, si = cfg.sizeIdx;
  var NNBSP = " ";

  var stage = root.querySelector("[data-dc-stage]");
  var dotsEl = root.querySelector("[data-dc-dots]");
  var navPrev = root.querySelector("[data-dc-prev]");
  var navNext = root.querySelector("[data-dc-next]");
  var zoomBtn = root.querySelector("[data-dc-zoom]");
  var form = root.querySelector("form.dc-pdp__form");
  var idInput = root.querySelector("[data-dc-variant-id]");
  var buy = root.querySelector("[data-dc-pdp-add]");   // ≠ data-dc-add (celui des cartes, géré par dc-site.js)
  var priceEl = root.querySelector("[data-dc-price]");
  var colorLabel = root.querySelector("[data-dc-color-label]");
  var tagsEl = root.querySelector(".dc-pdp__tags");

  /* ---------------------------------------------------------------
     Titre sur une seule ligne : on réduit la police jusqu'à ce qu'il tienne (min 12 px)
  --------------------------------------------------------------- */
  var titleH1 = root.querySelector(".dc-pdp__title");
  function fitTitle() {
    if (!titleH1) return;
    titleH1.style.fontSize = "";
    var avail = titleH1.clientWidth, need = titleH1.scrollWidth;
    if (need > avail) {
      var base = parseFloat(getComputedStyle(titleH1).fontSize);
      titleH1.style.fontSize = Math.max(12, Math.floor(base * (avail / need) * 99) / 100) + "px";
    }
  }
  fitTitle();
  window.addEventListener("resize", fitTitle);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);

  /* ---------------------------------------------------------------
     Bouton « Retour »
  --------------------------------------------------------------- */
  var backEl = root.querySelector("[data-dc-back]");
  if (backEl) {
    backEl.addEventListener("click", function (e) {
      if (document.referrer.indexOf(location.origin) === 0 && history.length > 1) { e.preventDefault(); history.back(); }
    });
  }

  /* ---------------------------------------------------------------
     Variantes et options
  --------------------------------------------------------------- */
  var current = null;
  variants.forEach(function (v) { if (v.id === cfg.currentId) current = v; });
  if (!current) current = variants[0];
  var selected = current ? current.options.slice() : [];

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function chipAvailable(idx, value) {
    return variants.some(function (v) {
      if (v.options[idx] !== value || !v.available) return false;
      return selected.every(function (s, j) { return j === idx || v.options[j] === s; });
    });
  }

  /* ---------------------------------------------------------------
     Galerie : groupes de photos par couleur
  --------------------------------------------------------------- */
  var allSlides = Array.prototype.slice.call(stage.children);
  var groups = {};
  (function buildGroups() {
    if (ci < 0 || !allSlides.length) return;
    var ids = allSlides.map(function (s) { return String(s.getAttribute("data-media-id")); });
    var starts = [];
    variants.forEach(function (v) {
      var color = v.options[ci];
      if (starts.some(function (s) { return s.color === color; })) return;
      var pos = v.mediaId != null ? ids.indexOf(String(v.mediaId)) : -1;
      if (pos >= 0) starts.push({ color: color, pos: pos });
    });
    starts.sort(function (a, b) { return a.pos - b.pos; });
    starts.forEach(function (s, i) {
      var from = i === 0 ? 0 : s.pos;
      var to = i + 1 < starts.length ? starts[i + 1].pos : allSlides.length;
      groups[s.color] = allSlides.slice(from, to);
    });
  })();

  var galleryCount = 0, currentIdx = 0;
  var galleryColor = null;
  var slideStep = function () {
    return (stage.children.length > 1 ? stage.children[1].offsetLeft - stage.children[0].offsetLeft : stage.clientWidth) || 1;
  };
  var LOOP_MS = 650;

  function refreshArrows() {
    var single = galleryCount <= 1;
    if (navPrev) navPrev.hidden = single;
    if (navNext) navNext.hidden = single;
  }
  function setActive(i) {
    currentIdx = i;
    if (dotsEl) Array.prototype.forEach.call(dotsEl.children, function (d, di) { d.classList.toggle("dc-is-active", di === i); });
    refreshArrows();
  }
  function goTo(i) {
    stage.scrollTo({ left: i * slideStep(), behavior: "smooth" });
    setActive(i);
  }
  // Boucle « infinie » : après la dernière photo on glisse vers une copie de la 1re (puis retour discret à la vraie 1re) ; idem avant la 1re.
  function loopNext() {
    var n = galleryCount, step = slideStep();
    var clone = stage.children[0].cloneNode(true);
    stage._busy = true;
    stage.appendChild(clone);
    stage.scrollTo({ left: n * step, behavior: "smooth" });
    setActive(0);
    setTimeout(function () {
      clone.remove();
      stage.style.scrollSnapType = "none";
      stage.scrollLeft = 0;
      requestAnimationFrame(function () { stage.style.scrollSnapType = ""; stage._busy = false; });
    }, LOOP_MS);
  }
  function loopPrev() {
    var n = galleryCount;
    var clone = stage.children[n - 1].cloneNode(true);
    stage._busy = true;
    stage.style.scrollSnapType = "none";
    stage.insertBefore(clone, stage.firstChild);
    stage.scrollLeft = slideStep();
    requestAnimationFrame(function () {
      stage.style.scrollSnapType = "";
      stage.scrollTo({ left: 0, behavior: "smooth" });
      setActive(n - 1);
      setTimeout(function () {
        clone.remove();
        stage.style.scrollSnapType = "none";
        stage.scrollLeft = (n - 1) * slideStep();
        requestAnimationFrame(function () { stage.style.scrollSnapType = ""; stage._busy = false; });
      }, LOOP_MS);
    });
  }
  if (navPrev) navPrev.addEventListener("click", function () { if (stage._busy) return; currentIdx <= 0 ? loopPrev() : goTo(currentIdx - 1); });
  if (navNext) navNext.addEventListener("click", function () { if (stage._busy) return; currentIdx >= galleryCount - 1 ? loopNext() : goTo(currentIdx + 1); });
  var scrollTimer;
  stage.addEventListener("scroll", function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { if (!stage._busy) setActive(Math.round(stage.scrollLeft / slideStep())); }, 80);
  });

  function renderGallery(color) {
    if (color === galleryColor) return;
    galleryColor = color;
    var slides = groups[color] || allSlides;
    stage.replaceChildren.apply(stage, slides.map(function (s) { return s.cloneNode(true); }));
    stage.scrollLeft = 0;
    galleryCount = slides.length;
    if (dotsEl) {
      dotsEl.innerHTML = "";
      if (galleryCount > 1) {
        for (var i = 0; i < galleryCount; i++) {
          var d = document.createElement("button");
          d.type = "button"; d.className = "dc-pdp__dot" + (i === 0 ? " dc-is-active" : "");
          d.setAttribute("aria-label", "Photo " + (i + 1));
          (function (n) { d.addEventListener("click", function () { goTo(n); }); })(i);
          dotsEl.appendChild(d);
        }
      }
    }
    setActive(0);
  }
  function goToPhoto(i) { stage.scrollTo({ left: i * slideStep(), behavior: "auto" }); setActive(i); }

  /* ---------------------------------------------------------------
     Visionneuse plein écran (bouton « + », mobile)
  --------------------------------------------------------------- */
  if (zoomBtn) {
    var lb = document.createElement("div");
    lb.className = "dc-r dc-lightbox";
    lb.hidden = true;
    lb.innerHTML =
      '<button type="button" class="dc-lightbox__close" aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="dc-lightbox__nav dc-lightbox__nav--prev" aria-label="Photo précédente"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="dc-lightbox__nav dc-lightbox__nav--next" aria-label="Photo suivante"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="dc-lightbox__track"></div>';
    document.body.appendChild(lb);
    var track = lb.querySelector(".dc-lightbox__track");
    var lprev = lb.querySelector(".dc-lightbox__nav--prev");
    var lnext = lb.querySelector(".dc-lightbox__nav--next");
    var lbStep = function () { return (track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : track.clientWidth) || 1; };
    var lbIndex = function () { return Math.round(track.scrollLeft / lbStep()); };
    var refreshNav = function () { var i = lbIndex(), n = track.children.length; lprev.hidden = i <= 0; lnext.hidden = i >= n - 1; };
    var openLb = function () {
      track.innerHTML = "";
      var slides = groups[galleryColor] || allSlides;
      slides.forEach(function (s) {
        var im = s.querySelector("img");
        var slide = document.createElement("div");
        slide.className = "dc-lightbox__slide";
        var big = document.createElement("img");
        big.src = im.getAttribute("data-full") || im.currentSrc || im.src;
        big.alt = im.alt;
        slide.appendChild(big);
        track.appendChild(slide);
      });
      lb.hidden = false;
      document.body.style.overflow = "hidden";
      track.scrollTo({ left: currentIdx * lbStep(), behavior: "auto" });
      refreshNav();
    };
    var closeLb = function () {
      if (lb.hidden) return;
      var i = lbIndex();
      lb.hidden = true;
      document.body.style.overflow = "";
      goToPhoto(i);
    };
    zoomBtn.addEventListener("click", openLb);
    lb.querySelector(".dc-lightbox__close").addEventListener("click", closeLb);
    lprev.addEventListener("click", function () { track.scrollBy({ left: -lbStep(), behavior: "smooth" }); });
    lnext.addEventListener("click", function () { track.scrollBy({ left: lbStep(), behavior: "smooth" }); });
    var lbTimer;
    track.addEventListener("scroll", function () { clearTimeout(lbTimer); lbTimer = setTimeout(refreshNav, 60); });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") closeLb();
      else if (e.key === "ArrowLeft") lprev.click();
      else if (e.key === "ArrowRight") lnext.click();
    });
  }

  /* ---------------------------------------------------------------
     Mise à jour de la fiche quand la variante change
  --------------------------------------------------------------- */
  var chips = Array.prototype.slice.call(root.querySelectorAll("[data-dc-chip]"));
  var ADD = cfg.labels.add, SOLD = cfg.labels.soldOut, UNAV = cfg.labels.unavailable;

  function refreshTags(v) {
    // « −X % » / « Best seller » ; « Unisexe » seulement s'il n'y a ni l'un ni l'autre (même règle que le prototype)
    if (!tagsEl || !v) return;
    var promo = !!v.compareAt;
    var badge = tagsEl.querySelector("[data-dc-badge]");
    if (badge) { badge.hidden = !promo; if (promo) badge.textContent = "−" + v.pct + " %"; }
    var best = tagsEl.querySelector("[data-dc-bestseller]");
    var isBest = best && best.getAttribute("data-on") === "1";
    tagsEl.querySelectorAll("[data-pdp-cat]").forEach(function (cat) { cat.hidden = promo || !!isBest; });
  }
  function refreshCommon() {
    chips.forEach(function (chip) {
      var idx = +chip.getAttribute("data-opt-index");
      var val = chip.getAttribute("data-value");
      chip.classList.toggle("dc-is-active", selected[idx] === val);
      chip.classList.toggle("dc-is-soldout", !chipAvailable(idx, val));
    });
    if (colorLabel && ci >= 0) colorLabel.textContent = selected[ci];
  }
  function update(changedIdx) {
    refreshCommon();
    var v = findVariant(selected);
    if (!v) {
      if (buy) { buy.disabled = true; buy.textContent = UNAV; }
      if (idInput) idInput.disabled = true;
      return;
    }
    current = v;
    if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
    if (buy) { buy.disabled = !v.available; buy.textContent = v.available ? ADD : SOLD; }
    var sbtn = document.querySelector("[data-dc-sticky-add]");
    if (sbtn) { sbtn.disabled = !v.available; sbtn.textContent = v.available ? ADD : SOLD; }
    if (priceEl) priceEl.innerHTML = (v.compareAt ? "<s>" + v.compareAt + NNBSP + "€</s>" : "") + v.price + NNBSP + "€";
    refreshTags(v);
    if (ci >= 0) { if (changedIdx === ci || galleryColor === null) renderGallery(v.options[ci]); }
    else if (galleryColor === null) renderGallery("");   // pas d'option couleur : toutes les photos
    try { var u = new URL(window.location.href); u.searchParams.set("variant", v.id); window.history.replaceState({}, "", u.toString()); } catch (e) {}
  }
  // Ouverture (arrivée sans ?variant=) comme le prototype : 1re couleur des pastilles (Noir), taille M, si cette variante est disponible
  if (!new URLSearchParams(location.search).get("variant")) {
    var start = selected.slice();
    if (ci >= 0) {
      var firstColor = root.querySelector('[data-dc-chip][data-opt-index="' + ci + '"]');
      if (firstColor) start[ci] = firstColor.getAttribute("data-value");
    }
    if (si >= 0) start[si] = "M";
    var vStart = findVariant(start);
    if (vStart && vStart.available) selected = start;
  }
  chips.forEach(function (chip) {
    var idx = +chip.getAttribute("data-opt-index");
    var val = chip.getAttribute("data-value");
    chip.addEventListener("click", function () { selected[idx] = val; update(idx); });
    // Survol d'une pastille de couleur : aperçu de son nom, puis retour à la couleur choisie
    if (idx === ci && colorLabel) {
      chip.addEventListener("mouseenter", function () { colorLabel.textContent = val; });
      chip.addEventListener("mouseleave", function () { colorLabel.textContent = selected[ci]; });
    }
  });
  update(ci);

  /* ---------------------------------------------------------------
     Ajout au panier (POST /cart/add.js puis mise à jour du point rose du panier)
  --------------------------------------------------------------- */
  function refreshCartBubble() {
    return fetch("/?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (data) {
      var html = data["cart-icon-bubble"];
      var target = document.querySelector("#cart-icon-bubble");
      if (!html || !target) return;
      var tmp = document.createElement("div");
      tmp.innerHTML = html;
      var fresh = tmp.querySelector("#cart-icon-bubble");
      target.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
    });
  }
  function addToCart() {
    if (!current || !current.available) return;
    var btns = [buy, document.querySelector("[data-dc-sticky-add]")].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: current.id, quantity: 1 })
    }).then(function (r) { if (!r.ok) throw new Error("add"); return typeof window.dcOpenCart === "function" ? window.dcOpenCart() : refreshCartBubble(); })   // tiroir panier (dc-cart-drawer.js) : recharge + ouvre
      .catch(function () {
        btns.forEach(function (b) { b.textContent = UNAV; });
        return new Promise(function (res) { setTimeout(res, 1400); });   // Shopify refuse (variante épuisée…) : on le dit un instant
      })
      .then(function () {
        btns.forEach(function (b) { b.disabled = !current.available; b.textContent = current.available ? ADD : SOLD; });
      });
  }
  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(); });

  /* ---------------------------------------------------------------
     Barre « Ajouter au panier » fixe (mobile) : visible dès que le bouton principal est sorti de l'écran par le haut
  --------------------------------------------------------------- */
  var sticky = document.querySelector("[data-dc-sticky]");
  if (sticky && buy) {
    sticky.querySelector("[data-dc-sticky-add]").addEventListener("click", function () { addToCart(); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle("dc-is-on", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(buy);
    }
  }

  /* ---------------------------------------------------------------
     Accordéon (ordinateur) + mobile : détails en liste grise + liens qui ouvrent un encart sur fond flou
  --------------------------------------------------------------- */
  var accItems = Array.prototype.slice.call(root.querySelectorAll(".dc-accordion__item"));
  accItems.forEach(function (item) {
    var btn = item.querySelector(".dc-accordion__btn");
    btn.addEventListener("click", function () {
      var open = item.classList.toggle("dc-is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
  var storyEl = root.querySelector(".dc-pdp__story");
  if (storyEl && accItems.length >= 1) {
    var specs = document.createElement("ul");
    specs.className = "dc-pdp__specs";
    var firstList = accItems[0].querySelector(".dc-accordion__panel ul");
    specs.innerHTML = firstList ? firstList.innerHTML : "";
    storyEl.appendChild(specs);
    // Pastilles « impact » sous « Détails du produit » (2026-10-18) : ordinateur = copie juste après le 1er item de l'accordéon ; mobile = l'original entre la liste grise et les liens.
    var ecoEl = storyEl.querySelector("[data-dc-eco]");
    if (ecoEl) { accItems[0].insertAdjacentElement("afterend", ecoEl.cloneNode(true)); storyEl.appendChild(ecoEl); }
    if (accItems.length > 1) {
      var links = document.createElement("div");
      links.className = "dc-pdp__links";
      accItems.slice(1).forEach(function (item, k) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("data-dc-pop", String(k + 1));
        b.textContent = item.querySelector(".dc-accordion__btn").firstChild.textContent.trim();
        links.appendChild(b);
      });
      storyEl.appendChild(links);

      var pop = document.createElement("div");
      pop.className = "dc-r dc-pdp-pop";
      pop.hidden = true;
      pop.innerHTML =
        '<div class="dc-pdp-pop__card" role="dialog" aria-modal="true">' +
        '<button type="button" class="dc-pdp-pop__close" aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<h2 class="dc-pdp-pop__title"></h2><ul class="dc-pdp-pop__body"></ul></div>';
      document.body.appendChild(pop);
      var closePop = function () { pop.hidden = true; document.body.style.overflow = ""; };
      links.querySelectorAll("[data-dc-pop]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var item = accItems[Number(btn.getAttribute("data-dc-pop"))];
          pop.querySelector(".dc-pdp-pop__title").textContent = btn.textContent;
          var list = item.querySelector(".dc-accordion__panel ul");
          pop.querySelector(".dc-pdp-pop__body").innerHTML = list ? list.innerHTML : "<li>" + item.querySelector(".dc-accordion__panel").textContent.trim() + "</li>";
          pop.hidden = false;
          document.body.style.overflow = "hidden";
        });
      });
      pop.addEventListener("click", function (e) { if (e.target === pop) closePop(); });
      pop.querySelector(".dc-pdp-pop__close").addEventListener("click", closePop);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !pop.hidden) closePop(); });
    }
  }
})();
